import { render, staticRenderFns } from "./RecordSearch.vue?vue&type=template&id=b2a592e8&scoped=true&"
import script from "./RecordSearch.vue?vue&type=script&lang=js&"
export * from "./RecordSearch.vue?vue&type=script&lang=js&"
import style0 from "./RecordSearch.vue?vue&type=style&index=0&id=b2a592e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2a592e8",
  null
  
)

export default component.exports